import { render, staticRenderFns } from "./Criteria.vue?vue&type=template&id=34f93414&scoped=true&"
import script from "./Criteria.vue?vue&type=script&lang=js&"
export * from "./Criteria.vue?vue&type=script&lang=js&"
import style0 from "./Criteria.vue?vue&type=style&index=0&id=34f93414&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f93414",
  null
  
)

export default component.exports